// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kJg7","col":"styles_col__3U8sH"};